import gql from 'graphql-tag'

export const GetConversations = gql`
    query getConversations($parent: String!) {
        conversations(where: { parent: { parent: $parent } }) {
            id
            title
            author {
                id
                oauthId
                display
            }
            parent {
                id
                parent
            }
            createdAt
            updatedAt
            unreadMessagesBy {
                id
                oauthId
            }
        }
    }
`
